import { Sanity$Feature } from '@otovo/shared/types/sanityTypes';
import FeatureContent from './FeatureContent';

type Props = {
  content: Sanity$Feature;
};

const Feature = ({ content }: Props) => {
  return (
    <div className="color-scheme-light bg-surface" data-testid="feature">
      <div className="mx-auto max-w-8xl px-4 py-16 md:px-6 md:py-20 lg:px-16 lg:py-24">
        <FeatureContent content={content} />
      </div>
    </div>
  );
};

export default Feature;
